module.exports = __webpack_public_path__ + "static/clouds-04d4681fd029b42cfe1f06afda17255b.jpg";